import { Box } from '@mui/joy';
import ControlPanelLayout from '../Controls/ControlPanelLayout';
import { Country } from '../Country/Country';
import { STATE_OPTIONS } from '../../lib/const';
import { useRoute } from '../../providers/RouteProvider';
import { useDataFormPage } from '../../providers/DataFormPageProvider';

export const NationalViewHighlights = () => {
	const { selectedState, setSelectedState } = useRoute();
	const { availableStates } = useDataFormPage();

	const availableStateProp = availableStates
		? availableStates
		: STATE_OPTIONS.map((state) => state.id.toUpperCase());
	return (
		<Box
			sx={{
				width: { xs: '295px', sm: '325.45px', md: '512px' }
			}}
		>
			<ControlPanelLayout
				page='national'
				selectOnly
				selectSx={{
					backgroundColor: '#FFFFFF',
					margin: 0,
					padding: 0,
					marginBottom: '44px'
				}}
			/>

			<Box
				sx={{
					height: '100%',
					width: { xs: '295px', sm: '325.45px', md: '452.11px' }
				}}
			>
				<Country
					active={selectedState ? [selectedState.toUpperCase()] : undefined}
					activeColor='opportunities'
					available={availableStateProp}
					includeLabels
					onStateClick={setSelectedState}
				/>
			</Box>
		</Box>
	);
};
